import { RuleValidity } from '@cbridge-tools/rules-data-grid';
import { IRuleValidation, RuleWarningType } from '../rule.interface';

export const getRuleValidity = <T extends IRuleValidation>(rule: T): RuleValidity | undefined => {
  if (rule.errors?.length > 0) {
    return RuleValidity.Error;
  }
  if (rule.warnings) {
    if (RuleWarningType.Unused in rule.warnings) {
      return RuleValidity.Unused;
    }
    if (RuleWarningType.Useless in rule.warnings) {
      return RuleValidity.Useless;
    }
  }
  return undefined;
};
